import React from "react";
import Icon from "../../../../../../../../../../../../components/icon";
import Button from "../../../../../../../../../../../../components/button";
import {useDispatch, useSelector} from "react-redux";
import {getSharingDetailsPopup} from "../../../../../../../../../../../../../actions/sharingDetailsActions";
import './index.css';

function ContactInfoDeleteBtn () {

    const contactDetails = useSelector(state => state.contactDetailsReducer.findContactDetails);
    const selectedContactsGroup = useSelector( state => state.contactsGroupItemReducer.getSelectedContactsGroup);

    const dispatch = useDispatch();

    const handleDeleteContact = () => {
        dispatch(getSharingDetailsPopup([true, 'delete_contact', {
            "id": contactDetails.id,
            "email": contactDetails?.phoneContactEntry.emailAddresses ? contactDetails?.phoneContactEntry.emailAddresses[0].email : "",
            "type": contactDetails?.phoneContactEntry.type
        }]))
    };

    return (
        <Button
            onClick={ handleDeleteContact }
            className="contact-info-delete-btn"
            disabled={selectedContactsGroup === null || contactDetails.deletable === false || (selectedContactsGroup && selectedContactsGroup.type === 'directory')}>
            <Icon name="trash" />
        </Button>
    )
}

export default ContactInfoDeleteBtn;
